export default __webpack_public_path__ + "static/favicon-07dc837cc7f1640e8587db2467eb6d8d.png";